'use strict';
import isFunction from 'lodash/isFunction';
import fuse from '../../../_libs/redux-fusion';
import {showPanel} from '../../actions/notificationsActions';
import {NotificationPanelButtonView} from './NotificationPanelButtonView';

const StreamedComponent = (state$, dispatch) => (props$) => {
  return props$
    .map(props => ({
      ...props,
      onClick: ev => {
        dispatch(showPanel());

        if (isFunction(props.onClick)) {
          props.onClick(ev);
        }
      },
    }));
};

export const NotificationPanelButtonContainer = fuse(StreamedComponent)(NotificationPanelButtonView);



// WEBPACK FOOTER //
// ./src/js/system/components/NotificationPanelButton/NotificationPanelButtonContainer.js